module.exports = "/_next/static/images/image-spaceship-large-a335b8c2b32b7edda6fd4710b23635ef.svg";